var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "social-accounts-panel" }, [
      _c("h2", { staticClass: "panel-title" }, [
        _vm._v("Link your social account"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "social-item-container" },
        [
          _c("google-signin-button", {
            staticClass: "social-item-button",
            attrs: { provider: "google", action: "link" },
          }),
          _vm._v(" "),
          _vm.hasLinkedProvider("GOOGLE")
            ? _c("rt-picture", {
                staticClass: "social-item-checked",
                attrs: { src: "/assets/app/class/pretest_completed_icon.svg" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "social-item-container" },
        [
          _c("google-signin-button", {
            staticClass: "social-item-button",
            attrs: { provider: "microsoft", action: "link" },
          }),
          _vm._v(" "),
          _vm.hasLinkedProvider("MICROSOFT")
            ? _c("rt-picture", {
                staticClass: "social-item-checked",
                attrs: { src: "/assets/app/class/pretest_completed_icon.svg" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "social-item-container" },
        [
          _c("google-signin-button", {
            staticClass: "social-item-button",
            attrs: { provider: "clever", action: "link" },
          }),
          _vm._v(" "),
          _vm.hasLinkedProvider("CLEVER")
            ? _c("rt-picture", {
                staticClass: "social-item-checked",
                attrs: { src: "/assets/app/class/pretest_completed_icon.svg" },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "setting-panel-footer" },
      [
        _c(
          "primary-button",
          {
            staticClass: "btn-close",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v("Close")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }